import { get } from 'lodash';
import { axiosService } from '../../services/axiosService';
import { useCreateMutation, MutationOptions } from '../../CRUD';
import { waitlistBaseModel } from './crud';
import { TWaitlist, TWaitlistsBulkRemoveParams } from './types';

async function waitlistsBulkRemoveQuery({ ids }: TWaitlistsBulkRemoveParams) {
  const response = await axiosService.post<TWaitlist>(
    '/waitlists/bulk/remove',
    [...ids],
  );
  return get(response, 'data');
}

export const waitlistsBulkRemove =
  () => (options?: MutationOptions<TWaitlist>) =>
    useCreateMutation<TWaitlist>(
      [...waitlistBaseModel.keys.many()],
      waitlistsBulkRemoveQuery,
      waitlistBaseModel.keys.fetchKey,
      options,
    );
